<div class="hpanel margin-bottom-5"  *ngIf="viewType=='MIN'">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-lg-12">
        <div class="community-admin">
          <a  class="pd-3" *ngFor="let item of admin | slice:0:10">
            <img [src]="item['image']"  (click)="route(item)" onerror="src='assets/images/userlogoimg.png'">
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <!-- <button class="btn btn-primary btn-xs" style="float: right;" *ngIf="admin.length!=0" >Invite</button> -->
      </div>
    </div>
  </div>
</div>
